import { NavigationExtras } from '@angular/router';

/** Guest inbound create: campaign slug must be queryParams, not part of the path. */
export function guestInboundCreateNav(
  companySlug: string,
  campaignSlug?: string
): { commands: string[]; extras?: NavigationExtras } {
  return {
    commands: ['/t', companySlug, 'testimonial', 'create'],
    extras: campaignSlug ? { queryParams: { cs: campaignSlug } } : undefined
  };
}

/** Guest interview-style create: absolute commands so the inbound module matches. */
export function guestInterviewCreateCommands(
  companySlug: string,
  campaignSlug: string
): string[] {
  return ['/interview/inbound/campaign/create', companySlug, campaignSlug];
}
